import { useCallback } from "react";
import { CartProduct, Product } from "@/types/product";
import { UnifiedMessage } from "@/hooks/use-messages";
import { ProductDetails } from "./ProductDetails";
import ChatMessages from "./ChatMessages";

type TextModeProps = {
  messages: UnifiedMessage[];
  productDescription: Product | null;
  setProductDescription: (
    product: Product | ((prevProduct: Product) => Product) | null,
  ) => void;
  cartItems: CartProduct[];
  onAddToCart: (product: Product | null) => void;
};

export default function TextMode({
  messages,
  productDescription,
  setProductDescription,
  cartItems,
  onAddToCart,
}: TextModeProps) {
  const handleNoClick = useCallback(() => {
    setProductDescription(null);
  }, [setProductDescription]);
  const handleYesClick = useCallback(() => {
    onAddToCart(productDescription);

    setTimeout(() => {
      setProductDescription(null);
    }, 300);
  }, [setProductDescription, onAddToCart, productDescription?.id]);

  return (
    <>
      {productDescription && (
        <>
          <div className="widget-displaying-results w-[100%]">
            <ProductDetails
              image={productDescription?.images?.[0]?.src}
              title={productDescription.title}
              currentPrice={productDescription?.variants?.[0]?.price}
              onYesClick={handleYesClick}
              onNoClick={handleNoClick}
              isAddedToCart={cartItems.some(
                (item) =>
                  item.variant_id === productDescription?.variants?.[0]?.id,
              )}
            />
          </div>
        </>
      )}
      <ChatMessages
        messages={messages}
        setProductDescription={setProductDescription}
      />
    </>
  );
}
